import React, { useEffect, useMemo, useState } from "react";
import styles from "./MaterialDetails.module.scss";
import {
  CONSTANTS_DATA,
  editMaterialValidationSchema,
  getColumns,
  getEditMaterialDefaultValues,
} from "./constants";
import TNButton from "../../../../../reusable-components/TNButton";
import {
  ButtonShape,
  ButtonSize,
  ButtonType,
} from "../../../../../enums/ButtonAttributesEnums";
import AddMaterialForm from "./AddMaterialsForm";
import { Drawer, Table, Button } from "antd";
import {
  MaterialTruck,
  useMaterials,
} from "../../../../../context/materialListingContext";
import ConditionalRender from "../../../../../reusable-components/ConditionalRender";
import { useFormContext } from "react-hook-form";
import { washedStatus } from "./AddMaterialsForm/constants";
import {
  getDefaultValues,
  truckMaterialDetailsValidation,
} from "../../constants";
import Form from "../../../../Form";
import CreateJobServices from "../../../../../services/createJob.services";
import { MaterialDetailsType } from "../../../../../Types/materialTypes";
import EditMaterialsForm from "./EditMaterialsForm";
import BidToolReferenceForm from "../BidToolReferenceForm";

const MaterialDetails = ({
  isEditable,
  dropOffLatLng,
  dropOff,
}: MaterialDetailsType) => {
  const { FetchSettingsBidConfig } = CreateJobServices();
  const { data: bidConfigSettingsData } = FetchSettingsBidConfig(undefined);

  const { NO_DATA, TITLE } = CONSTANTS_DATA;
  const { setValue } = useFormContext();
  const [editData, setEditData] = useState(undefined);
  const [isOpen, setIsOpen] = useState(false);
  const [bidToolReferenceOpen, setBidToolReferenceOpen] = useState<boolean>(false);
  const [selectedOrderData, setSelectedOrderData] = useState<object>({});
  const handleOpenDrawer = () => {
    setIsOpen(true);
  };
  const handleCloseDrawer = () => {
    setValue("materialCategories", null);
    setValue("searchRadius", "");
    setValue("materialType", undefined);
    setValue("materialName", undefined);
    setValue("testingStatus", undefined);
    setValue("washedStatus", undefined);
    setValue("supply", undefined);
    setValue("quarryName", null);
    setValue("materialDiameter", "");

    setIsOpen(false);
  };
  const {
    materialTruckList,
    removeTruckMaterial,
    getTruckMaterial,
    updateMaterial,
  } = useMaterials();

  const handleDeleteRow = (row?: any) => {
    removeTruckMaterial(row);
  };

  const [defaultEditValues, setDefaultEditValues] = useState({});
  const [editedValues, setEditedValues] = useState({});
  const [currentSelectedRow, setSelectedRow] = useState(null);

  const [isEditDrawerOpen, setIsEditDrawerOpen] = useState(false);
  const handleOpenEditDrawer = () => {
    setIsEditDrawerOpen(true);
  };

  const handleEditRow = (row?: any) => {
    setDefaultEditValues(getEditMaterialDefaultValues(row));
    handleOpenEditDrawer();
  };

  const handleBidToolReferenceOpen = (record) => {
    setSelectedOrderData({
      ...materialsDefaultData,
      truckPrice: record?.truckingPrice,
      truckingCost: record?.truckingCost,
      actualBid: record?.truckingPrice,
    })
    setBidToolReferenceOpen(true);
  };

  const handleBidToolReferenceClose = () => {
    setSelectedOrderData({})
    setBidToolReferenceOpen(false)
  };

  const materialsDefaultData = useMemo(() => {
    if (!bidConfigSettingsData) {
      return {};
    }
    return getDefaultValues(
      false,
      undefined,
      bidConfigSettingsData,
      undefined,
      undefined,
      dropOff,
      dropOffLatLng
    );
  }, [bidConfigSettingsData, dropOff, dropOffLatLng]);

  const columns = getColumns({
    handleSelectVendor: () => {},
    isEditable: true,
    handleDeleteRow: handleDeleteRow,
    handleEditRow: handleEditRow,
    handleOpenBidTool: handleBidToolReferenceOpen,
  });
  const data = materialTruckList?.map((item: MaterialTruck, index: number) => ({
    vendorName: item?.vendor,
    materialName: item?.materialName,
    isBlocked: item?.isBlocked,
    materialCost: item?.materialCost,
    materialQuantity: item?.materialQuantity,
    materialQuantityUnitType: item?.materialQuantityUnitType,
    materialPrice: item?.materialPrice,
    truckingCost: item?.truckingCost,
    truckingPrice: item?.truckingPrice,
    truckType: item?.truckType,
    materialCostType: item?.materialCostType,
    materialPriceType: item?.materialPriceType,
    truckingCostType: item?.truckingCostType,
    truckingPriceType: item?.truckingPriceType,
    landedPriceType: item?.landedPriceType,
    landedPrice: item?.landedPrice,
    minimumHours: item?.minimumHours,
    id: item?.uniqKey,
    locked: item?.locked,
  }));
  useEffect(() => {}, [isEditDrawerOpen]);
  return (
    <>
      <BidToolReferenceForm
        selectedOrderData={selectedOrderData}
        isOpen={bidToolReferenceOpen}
        handleClose={handleBidToolReferenceClose} 
      />
      <Drawer
        visible={isOpen}
        maskClosable={false}
        destroyOnClose
        className={styles.AddMaterialForm}
        closable={true}
        mask={true}
        getContainer={false}
        onClose={handleCloseDrawer}
        placement="right"
        width="80%"
        height="100vh"
        title={<div className={styles.DrawerHeaderContainer}>{TITLE}</div>}
        headerStyle={{
          backgroundColor: "#586370",
          padding: "1rem",
          color: "white",
        }}
        size="large"
      >
        <Form
          defaultValues={materialsDefaultData}
          validationSchema={truckMaterialDetailsValidation}
          key={JSON.stringify(materialsDefaultData)}
        >
          {() => {
            return (
              <AddMaterialForm
                onClose={handleCloseDrawer}
                editData={editData}
                isEditable={isEditable}
                dropOffLatLng={dropOffLatLng}
              />
            );
          }}
        </Form>
      </Drawer>
      <Form
        defaultValues={defaultEditValues}
        validationSchema={editMaterialValidationSchema}
        key={JSON.stringify(defaultEditValues)}
      >
        {({ control: { handleSubmit, _reset } }) => {
          const handleCloseEditDrawer = () => {
            setEditedValues({});
            setIsEditDrawerOpen(false);
            _reset();
          };

          const handleUpdate = () => {
            if (currentSelectedRow && editedValues) {
              updateMaterial(currentSelectedRow, editedValues);
            }
            setEditedValues(null);
            setSelectedRow(null);
            handleCloseEditDrawer();
          };
          return (
            <Drawer
              visible={isEditDrawerOpen}
              maskClosable={false}
              destroyOnClose
              className={styles.EditMaterialForm}
              closable={true}
              mask={true}
              getContainer={false}
              onClose={handleCloseEditDrawer}
              placement="right"
              width="70%"
              height="100vh"
              title={
                <div className={styles.DrawerHeaderContainer}>
                  Edit Material Details
                </div>
              }
              size="large"
              footer={
                <div className={styles.ButtonContainer}>
                  <div
                    className={styles.CancelButton}
                    onClick={handleCloseEditDrawer}
                  >
                    Cancel
                  </div>
                  <Button
                    type={ButtonType.PRIMARY}
                    shape={ButtonShape.DEFAULT}
                    size={ButtonSize.LARGE}
                    onClick={handleSubmit(handleUpdate)}
                  >
                    Save
                  </Button>
                </div>
              }
            >
              <EditMaterialsForm
                defaultValues={defaultEditValues}
                setEditedValues={setEditedValues}
                setSelectedRow={setSelectedRow}
              />
            </Drawer>
          );
        }}
      </Form>
      <div className={styles.ButtonsContainer}>
        <TNButton
          size={ButtonSize.LARGE}
          text="Add Material Order"
          shape={ButtonShape.DEFAULT}
          onClick={handleOpenDrawer}
        />
      </div>
      <ConditionalRender
        visible={materialTruckList?.length}
        fallback={
          <div className={styles.MaterialDetailsContainer}>
            <h1>{NO_DATA}</h1>
            <TNButton
              size={ButtonSize.LARGE}
              shape={ButtonShape.DEFAULT}
              text="Add Material Order"
              onClick={handleOpenDrawer}
            />
          </div>
        }
      >
        <Table columns={columns} dataSource={data} />
      </ConditionalRender>
    </>
  );
};

export default MaterialDetails;
